export const FIELD_VALUE_TYPES = {
  INTEGER: 'integer',
  LETTERS: 'letters',
  LETTERS_SPACE: 'letters_space',
  DECIMALS: 'decimals',
  PERCENTAGE: 'percentage',
  ANY: 'any',
  USERNAME: 'username',
  AWS_GROUP_NAME: 'aws_group_name',
  EMAIL: 'email',
  PLUS_SIGN_NUMBERS: 'plus_sign_numbers',
  PHONE_NUMBER: 'phone_number',
  ORDER_ID: 'order_id',
};

export const FIELD_TYPES = {
  TEXT: 'text',
  PASSWORD: 'password',
  NUMBER: 'number',
  EMAIL: 'email',
};

export const FIELD_ALIGN = {
  LEFT: 'left',
  RIGHT: 'right',
};

const ONLY_INTEGER = /^[0-9\b]+$/;
const ONLY_LETTERS = /^[A-Za-z]+$/;
const ONLY_LETTERS_SPACE = /^[a-zA-Z\s]*$/;
const ONLY_INTEGER_OR_DECIMALS = /^(?:0|[1-9][0-9]*)(?:\.([0-9]{1,2})?)?$/;
const ONLY_NUMBER_UP_TO_HUNDRED = /^(([1-9]?\d)(?:\.(\d{1,2})?)?|100(\.00?)?)$/;
const ONLY_USERNAME_FORMAT = /^[a-z0-9_-]+$/;
const ONLY_AWS_GROUP_NAME_FORMAT = /^[a-zA-Z0-9_.-]+$/;
const ONLY_EMAIL_ADDRESS = /^[\S]+$/;
const ONLY_PLUS_SIGN_NUMBERS = /^([+])?[\d]*$/;
const ONLY_NUMBERS_PARENTHESIS_HYPHEN_SPACE = /^[-+.()0-9\s]*$/;
const ONLY_NUMBERS_LETTERS_HYPEN = /^[-0-9A-Za-z]*$/;

export const VALUE_TYPES_REGEXP = {
  [FIELD_VALUE_TYPES.INTEGER]: ONLY_INTEGER,
  [FIELD_VALUE_TYPES.LETTERS]: ONLY_LETTERS,
  [FIELD_VALUE_TYPES.LETTERS_SPACE]: ONLY_LETTERS_SPACE,
  [FIELD_VALUE_TYPES.DECIMALS]: ONLY_INTEGER_OR_DECIMALS,
  [FIELD_VALUE_TYPES.PERCENTAGE]: ONLY_NUMBER_UP_TO_HUNDRED,
  [FIELD_VALUE_TYPES.USERNAME]: ONLY_USERNAME_FORMAT,
  [FIELD_VALUE_TYPES.AWS_GROUP_NAME]: ONLY_AWS_GROUP_NAME_FORMAT,
  [FIELD_VALUE_TYPES.EMAIL]: ONLY_EMAIL_ADDRESS,
  [FIELD_VALUE_TYPES.PLUS_SIGN_NUMBERS]: ONLY_PLUS_SIGN_NUMBERS,
  [FIELD_VALUE_TYPES.PHONE_NUMBER]: ONLY_NUMBERS_PARENTHESIS_HYPHEN_SPACE,
  [FIELD_VALUE_TYPES.ORDER_ID]: ONLY_NUMBERS_LETTERS_HYPEN,
};